<template>
  <div class="collapse carded">
	  	<div class="collapse-bg"></div>
		<div class="collapse-selection-container">
			<!-- Mobile: Using select for item selection -->
			<div class="collapse-selection-compact">
				<select @change="currentItemIndex = Number($event.target.value)">
					<option
							v-for="(item, index) in collapseItems"
							:key="item.title"
							:value="index">
						{{ item.title }}
					</option>
				</select>
			</div>

			<div class="collapse-selection">
				<div
						v-for="(item, index) in collapseItems"
						:key="item.title"
						class="collapse-selector"
						:class="{ 'active': currentItemIndex == index }">
					<div class="card-layout card-content" @click="currentItemIndex = index" :style="{ '--item-color': item.color }">
						{{ item.title }}
					</div>
				</div>
			</div>
		</div>
		<div class="collapse-item-content-wrapper">
			<div v-for="(item, index) in collapseItems"
                :key="item.title"
                class="collapse-item-content"
                :class="{ 'active': currentItemIndex === index }">
				<div class="title mb-5 lg:mb-0" v-html="item.title" :style="{ color: item.color }"></div>
                <div class="text" v-html="item.text"></div>
            </div>
		</div>
	</div>
</template>

<script>
export default {
    props: {
		items: {
			type: String
		}
	},
	data() {
		return {
			collapseItems: JSON.parse(this.items) ?? {},
			currentItemIndex: 0
		};
	},
	watch: {
		currentItemIndex: function() {
			console.log(this.currentItemIndex);
		}
	}
}
</script>
